import React from "react";

/*
  Each Art returns an SVG that fills its parent square tile.
  Designed to closely mimic the visual style of the reference screenshots.
*/

// 1) Common Number — big white "C" on orange-red
export function ArtCommon() {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <rect width="200" height="200" fill="#FF5D3A" />
      <text
        x="100"
        y="145"
        textAnchor="middle"
        fontSize="180"
        fontWeight="900"
        fontFamily="Fraunces, Georgia, serif"
        fill="#FFFFFF"
      >
        C
      </text>
    </svg>
  );
}

// 2) Blog — cork board texture with colored BLOG letters
export function ArtBlog() {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <defs>
        <pattern id="cork" width="8" height="8" patternUnits="userSpaceOnUse">
          <rect width="8" height="8" fill="#C89A6A" />
          <circle cx="2" cy="2" r="1" fill="#A67D4E" />
          <circle cx="6" cy="5" r="1" fill="#B3885A" />
          <circle cx="3" cy="6" r="0.6" fill="#8E6A3F" />
        </pattern>
      </defs>
      <rect width="200" height="200" fill="url(#cork)" />
      {/* Pins */}
      <circle cx="55" cy="55" r="6" fill="#F4C400" stroke="#7A5C00" strokeWidth="1" />
      <circle cx="95" cy="50" r="6" fill="#E53935" stroke="#7C1F1B" strokeWidth="1" />
      <circle cx="130" cy="55" r="6" fill="#43A047" stroke="#1F5A22" strokeWidth="1" />
      <circle cx="165" cy="52" r="6" fill="#1E88E5" stroke="#0D3E7A" strokeWidth="1" />
      {/* Paper cards with letters */}
      <g fontFamily="Fraunces, Georgia, serif" fontWeight="900" fontSize="46">
        <g transform="rotate(-8 55 105)">
          <rect x="30" y="70" width="55" height="70" fill="#FFFFFF" />
          <text x="57" y="122" textAnchor="middle" fill="#F4C400">B</text>
        </g>
        <g transform="rotate(4 95 105)">
          <rect x="72" y="72" width="50" height="66" fill="#FFFFFF" />
          <text x="97" y="118" textAnchor="middle" fill="#E53935">L</text>
        </g>
        <g transform="rotate(-3 130 108)">
          <rect x="108" y="74" width="52" height="66" fill="#FFFFFF" />
          <text x="134" y="121" textAnchor="middle" fill="#43A047">O</text>
        </g>
        <g transform="rotate(6 165 108)">
          <rect x="146" y="72" width="52" height="70" fill="#FFFFFF" />
          <text x="172" y="122" textAnchor="middle" fill="#1E88E5">G</text>
        </g>
      </g>
    </svg>
  );
}

// 3) Dream Number — sleeping cloud with rainbow unicorn horn + star
export function ArtDream() {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <rect width="200" height="200" fill="#FF5D3A" />
      {/* Star */}
      <polygon
        points="152,26 160,44 179,46 165,60 168,79 152,70 136,79 139,60 125,46 144,44"
        fill="#FFD54F"
        stroke="#8B6B00"
        strokeWidth="1.5"
      />
      {/* Unicorn horn (rainbow stripes) */}
      <g>
        <polygon points="98,80 92,116 108,116" fill="#FF5252" stroke="#333" strokeWidth="1.5" />
        <line x1="94" y1="90" x2="108" y2="93" stroke="#FFC107" strokeWidth="3" />
        <line x1="93" y1="99" x2="109" y2="102" stroke="#4CAF50" strokeWidth="3" />
        <line x1="92" y1="108" x2="110" y2="111" stroke="#2196F3" strokeWidth="3" />
      </g>
      {/* Cloud body */}
      <g fill="#FFFFFF" stroke="#333" strokeWidth="2">
        <ellipse cx="70" cy="140" rx="28" ry="22" />
        <ellipse cx="105" cy="128" rx="34" ry="26" />
        <ellipse cx="140" cy="138" rx="30" ry="22" />
        <ellipse cx="105" cy="150" rx="55" ry="18" />
      </g>
      {/* Sleeping eyes (curved lines) */}
      <path d="M85 135 q6 -6 12 0" stroke="#333" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <path d="M115 135 q6 -6 12 0" stroke="#333" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      {/* Cheeks */}
      <circle cx="86" cy="146" r="4" fill="#F8B4B4" opacity="0.85" />
      <circle cx="126" cy="146" r="4" fill="#F8B4B4" opacity="0.85" />
    </svg>
  );
}

// 4) Predict Number — chart with rising arrow
export function ArtPredict() {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <rect width="200" height="200" fill="#2B3E52" />
      {/* Pie chart */}
      <g transform="translate(120 120)">
        <circle r="30" fill="#E0E7EF" />
        <path d="M0 0 L0 -30 A30 30 0 0 1 26 15 Z" fill="#7C3AED" />
        <path d="M0 0 L26 15 A30 30 0 0 1 -25 17 Z" fill="#F59E0B" />
        <path d="M0 0 L-25 17 A30 30 0 0 1 0 -30 Z" fill="#22C55E" />
      </g>
      {/* Bar chart */}
      <g fill="#E5E7EB">
        <rect x="35" y="120" width="16" height="45" />
        <rect x="56" y="100" width="16" height="65" />
        <rect x="77" y="130" width="16" height="35" />
      </g>
      {/* Big arrow */}
      <path
        d="M20 155 L60 120 L85 140 L120 90 L150 60"
        stroke="#C084FC"
        strokeWidth="7"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polygon points="150,60 132,64 145,78" fill="#C084FC" />
      {/* Little person */}
      <g fill="#F59E0B" stroke="#333" strokeWidth="1">
        <circle cx="45" cy="60" r="7" />
        <rect x="42" y="68" width="8" height="18" />
      </g>
    </svg>
  );
}

// 5) Predict Target — Direct / House / Ending arrows
export function ArtPredictTarget() {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <rect width="200" height="200" fill="#1E4D2B" />
      <rect x="6" y="6" width="188" height="188" fill="none" stroke="#7CFC00" strokeWidth="4" />
      {/* Arrow 1 (D - white) */}
      <g>
        <polygon points="30,50 145,50 155,60 145,70 30,70" fill="#FFFFFF" />
        <text x="150" y="66" fontSize="14" fontWeight="900" fill="#1E4D2B">D</text>
      </g>
      {/* Arrow 2 (H - orange, left facing) */}
      <g>
        <polygon points="170,90 55,90 45,100 55,110 170,110" fill="#F59E0B" />
        <text x="40" y="106" fontSize="14" fontWeight="900" fill="#1E4D2B">H</text>
      </g>
      {/* Arrow 3 (E - red) */}
      <g>
        <polygon points="30,130 145,130 155,140 145,150 30,150" fill="#EF4444" />
        <text x="150" y="146" fontSize="14" fontWeight="900" fill="#1E4D2B">E</text>
      </g>
    </svg>
  );
}

// 6) Previous Result — clipboard with checklist
export function ArtPrevious() {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <rect width="200" height="200" fill="#2AA39A" />
      <g stroke="#FFFFFF" strokeWidth="6" fill="none">
        <rect x="55" y="45" width="90" height="120" rx="4" />
        <path d="M75 78 h50" />
        <path d="M75 105 h50" />
        <path d="M75 132 h50" />
      </g>
      <g stroke="#FFFFFF" strokeWidth="5" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <rect x="130" y="66" width="18" height="18" />
        <polyline points="130,70 138,78 148,60" />
      </g>
    </svg>
  );
}

// 7) Teer Calendar — calendar with July / 17
export function ArtCalendar() {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <rect width="200" height="200" fill="#2AA39A" />
      <g fill="#FFFFFF">
        <rect x="35" y="55" width="130" height="115" rx="6" />
        <rect x="35" y="55" width="130" height="26" fill="#EF4444" rx="6" />
      </g>
      <text x="100" y="76" textAnchor="middle" fontSize="16" fontWeight="900" fill="#FFFFFF">
        July
      </text>
      <text
        x="100"
        y="135"
        textAnchor="middle"
        fontSize="46"
        fontWeight="900"
        fill="#0D1B2A"
        fontFamily="Fraunces, Georgia, serif"
      >
        17
      </text>
      <g stroke="#0D1B2A" strokeWidth="3">
        <line x1="65" y1="45" x2="65" y2="65" />
        <line x1="135" y1="45" x2="135" y2="65" />
      </g>
    </svg>
  );
}

// 8) Reputed Counter — big target with arrows
export function ArtReputed() {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <rect width="200" height="200" fill="#0D1B2A" />
      <circle cx="100" cy="100" r="70" fill="#F5F5F5" />
      <circle cx="100" cy="100" r="55" fill="#EF4444" />
      <circle cx="100" cy="100" r="42" fill="#F5F5F5" />
      <circle cx="100" cy="100" r="30" fill="#EF4444" />
      <circle cx="100" cy="100" r="18" fill="#F5F5F5" />
      <circle cx="100" cy="100" r="8" fill="#EF4444" />
      {/* Stand */}
      <g stroke="#8B6B00" strokeWidth="6" strokeLinecap="round">
        <line x1="60" y1="180" x2="90" y2="150" />
        <line x1="140" y1="180" x2="110" y2="150" />
      </g>
      {/* Arrows */}
      <g stroke="#111" strokeWidth="3" strokeLinecap="round">
        <line x1="30" y1="30" x2="100" y2="100" />
        <line x1="70" y1="20" x2="100" y2="100" />
        <line x1="20" y1="70" x2="100" y2="100" />
      </g>
      <g fill="#EF4444" stroke="#000" strokeWidth="1">
        <polygon points="20,20 34,24 30,38 16,34" />
        <polygon points="60,10 74,14 70,28 56,24" />
        <polygon points="10,60 24,64 20,78 6,74" />
      </g>
    </svg>
  );
}

// 9) Night Teer App — phone in hand with check
export function ArtApp() {
  return (
    <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
      <rect width="200" height="200" fill="#5B1A6E" />
      {/* Phone */}
      <g>
        <rect x="65" y="35" width="70" height="120" rx="10" fill="#F5F5F5" stroke="#0D1B2A" strokeWidth="3" />
        <rect x="72" y="45" width="56" height="90" fill="#FFFFFF" />
        <circle cx="100" cy="147" r="4" fill="#0D1B2A" />
      </g>
      {/* Check box on screen */}
      <g stroke="#0D1B2A" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <rect x="82" y="60" width="36" height="36" rx="4" />
        <polyline points="86,80 96,90 116,66" />
      </g>
      {/* Hand */}
      <path
        d="M55 155 q10 -10 30 -10 h30 q20 0 30 10 v25 h-90 z"
        fill="#F5F5F5"
        stroke="#0D1B2A"
        strokeWidth="3"
      />
    </svg>
  );
}

export const ART_MAP = {
  "common-number": ArtCommon,
  blog: ArtBlog,
  "dream-number": ArtDream,
  "predict-number": ArtPredict,
  "predict-target": ArtPredictTarget,
  "previous-result": ArtPrevious,
  "teer-calendar": ArtCalendar,
  "reputed-counter": ArtReputed,
  "night-teer-app": ArtApp,
};
